import AppState from "../AppState";

export const getGlobalAlerts = (state: AppState) => {
  return state.globalAlert.alertsProps;
};
